import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { phoneServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const phoneInstance = axios.create({
  baseURL: phoneServiceUrl,
  headers,
})

phoneInstance.interceptors.request.use(config => {
  return requestInterceptor(config)
}, error => Promise.reject(error))

phoneInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default phoneInstance
